import { render, staticRenderFns } from "./MasterMaterial.vue?vue&type=template&id=61594698&scoped=true"
import script from "./MasterMaterial.vue?vue&type=script&lang=js"
export * from "./MasterMaterial.vue?vue&type=script&lang=js"
import style0 from "./MasterMaterial.vue?vue&type=style&index=0&id=61594698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61594698",
  null
  
)

export default component.exports